<template>
  <div class="atualizar-perfil-page">
    <div class="container q-py-xl">
      <div class="row justify-center">
        <div class="col-12 col-md-8 col-lg-6">
          <!-- Breadcrumb/Voltar -->
          <q-btn
            flat
            round
            icon="arrow_back"
            color="primary"
            size="md"
            class="q-mb-md"
            @click="voltarPerfil"
          >
            <q-tooltip>Voltar ao Perfil</q-tooltip>
          </q-btn>

          <!-- Card do Formulário -->
          <q-card flat bordered class="form-card">
            <q-card-section class="q-pb-none">
              <div class="text-h5 text-weight-bold text-grey-9">
                Atualizar Informações Pessoais
              </div>
              <div class="text-body2 text-grey-6 q-mt-xs">
                Mantenha seus dados sempre atualizados
              </div>
            </q-card-section>

            <q-separator class="q-my-md" />

            <q-card-section>
              <q-form @submit="salvarDados" class="q-gutter-md">
                <!-- Upload de Foto -->
                <div class="foto-section text-center q-mb-lg">
                  <div class="foto-wrapper">
                    <q-avatar size="120px" class="profile-avatar">
                      <img :src="previewFoto || usuario.foto" alt="Foto de perfil">
                    </q-avatar>
                    
                    <!-- Botão de Upload sobreposto -->
                    <q-btn
                      round
                      color="primary"
                      icon="photo_camera"
                      size="sm"
                      class="upload-btn"
                      @click="selecionarFoto"
                    >
                      <q-tooltip>Alterar foto</q-tooltip>
                    </q-btn>
                  </div>
                  
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    style="display: none"
                    @change="handleFileUpload"
                  />
                  
                  <div class="text-caption text-grey-6 q-mt-md">
                    Formatos aceitos: JPG, PNG (máx. 5MB)
                  </div>
                </div>

                <!-- Nome -->
                <q-input
                  v-model="usuario.nome"
                  outlined
                  label="Nome Completo *"
                  placeholder="Digite seu nome completo"
                  :rules="[
                    val => !!val || 'Nome é obrigatório',
                    val => val.length >= 3 || 'Nome deve ter no mínimo 3 caracteres'
                  ]"
                  lazy-rules
                >
                  <template v-slot:prepend>
                    <q-icon name="person" color="primary" />
                  </template>
                </q-input>

                <!-- Email (não editável) -->
                <q-input
                  v-model="usuario.email"
                  outlined
                  label="E-mail"
                  type="email"
                  readonly
                  disable
                  hint="O e-mail não pode ser alterado"
                >
                  <template v-slot:prepend>
                    <q-icon name="mail" color="grey-5" />
                  </template>
                  <template v-slot:append>
                    <q-icon name="lock" color="grey-5" size="20px">
                      <q-tooltip>Campo não editável</q-tooltip>
                    </q-icon>
                  </template>
                </q-input>

                <!-- Contacto -->
                <q-input
                  v-model="usuario.contacto"
                  outlined
                  label="Contacto *"
                  placeholder="+258 84 123 4567"
                  mask="+258 ## ### ####"
                  unmasked-value
                  :rules="[
                    val => !!val || 'Contacto é obrigatório',
                    val => val.length >= 9 || 'Contacto inválido'
                  ]"
                  lazy-rules
                >
                  <template v-slot:prepend>
                    <q-icon name="phone" color="primary" />
                  </template>
                </q-input>

                <!-- WhatsApp -->
                <q-input
                  v-model="usuario.whatsapp"
                  outlined
                  label="WhatsApp"
                  placeholder="+258 84 123 4567"
                  mask="+258 ## ### ####"
                  unmasked-value
                  hint="Deixe em branco se for o mesmo que o contacto"
                  :rules="[
                    val => !val || val.length >= 9 || 'WhatsApp inválido'
                  ]"
                  lazy-rules
                >
                  <template v-slot:prepend>
                    <q-icon color="green-7"> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                        </svg>
                    </q-icon>
                  </template>
                  <template v-slot:append>
                    <q-btn
                      flat
                      dense
                      icon="content_copy"
                      size="sm"
                      color="grey-6"
                      @click="copiarContacto"
                    >
                      <q-tooltip>Copiar do contacto</q-tooltip>
                    </q-btn>
                  </template>
                </q-input>

                <!-- Botões de Ação -->
                <div class="row q-col-gutter-sm q-mt-md">
                  <div class="col-12 col-sm-6">
                    <q-btn
                      outline
                      color="grey-7"
                      label="Cancelar"
                      icon="close"
                      class="full-width"
                      @click="cancelar"
                    />
                  </div>
                  <div class="col-12 col-sm-6">
                    <q-btn
                      type="submit"
                      unelevated
                      color="primary"
                      label="Salvar Alterações"
                      icon="check"
                      class="full-width"
                      :loading="salvando"
                    />
                  </div>
                </div>
              </q-form>
            </q-card-section>
          </q-card>

          <!-- Card de Dicas -->
          <q-card flat bordered class="q-mt-md tips-card">
            <q-card-section>
              <div class="row items-center q-mb-sm">
                <q-icon name="lightbulb" color="amber-7" size="24px" />
                <span class="text-subtitle2 text-weight-bold q-ml-sm">
                  Dicas de Segurança
                </span>
              </div>
              <q-list dense>
                <q-item>
                  <q-item-section side>
                    <q-icon name="check_circle" color="green-6" size="18px" />
                  </q-item-section>
                  <q-item-section>
                    <q-item-label caption class="text-grey-8">
                      Use uma foto de perfil clara e profissional
                    </q-item-label>
                  </q-item-section>
                </q-item>
                <q-item>
                  <q-item-section side>
                    <q-icon name="check_circle" color="green-6" size="18px" />
                  </q-item-section>
                  <q-item-section>
                    <q-item-label caption class="text-grey-8">
                      Mantenha seus dados de contacto atualizados
                    </q-item-label>
                  </q-item-section>
                </q-item>
                <q-item>
                  <q-item-section side>
                    <q-icon name="check_circle" color="green-6" size="18px" />
                  </q-item-section>
                  <q-item-section>
                    <q-item-label caption class="text-grey-8">
                      Verifique suas informações antes de salvar
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/vuex/store';
import Swal from 'sweetalert2';

const router = useRouter();
const fileInput = ref(null);
const previewFoto = ref(null);
const fotoArquivo = ref(null); // Armazena o arquivo original
const salvando = ref(false);

// Dados do usuário (devem vir do Vuex/store)
const usuario = ref({
  nome: '',
  email: '',
  contacto: '',
  whatsapp: '',
  foto: ''
});

// Função para selecionar foto
const selecionarFoto = () => {
  fileInput.value.click();
};
onMounted(() => {
    usuario.value = {
        nome: store.state.auth.user.name,
        email: store.state.auth.user.email,
        contacto: store.state.auth.user.phone || '',
        whatsapp: store.state.auth.user.whatsapp || '',
        foto: store.state.auth.user.photo || 'https://amzn-s3-goldenkey.s3.us-east-2.amazonaws.com/properties/icon2.png'
    }
})
// Função para lidar com upload de arquivo
const handleFileUpload = (event) => {
  const file = event.target.files[0];
  
  if (file) {
    // Validar tamanho (máx 5MB)
    if (file.size > 5 * 1024 * 1024) {
      
      return;
    }

    // Validar tipo
    if (!file.type.startsWith('image/')) {
      return;
    }

    // Armazenar o arquivo original
    fotoArquivo.value = file;

    // Criar preview
    const reader = new FileReader();
    reader.onload = (e) => {
      previewFoto.value = e.target.result;
    };
    reader.readAsDataURL(file);
  }
};

// Copiar contacto para WhatsApp
const copiarContacto = () => {
  usuario.value.whatsapp = usuario.value.contacto;
};

// Salvar dados
const salvarDados = () => {
  salvando.value = true;

  // Criar FormData para enviar arquivo
  const formData = new FormData();
  
  // Adicionar dados do usuário
  formData.append('name', usuario.value.nome);
  formData.append('phone', usuario.value.contacto);
  formData.append('whatsapp', usuario.value.whatsapp || '');
  
  // Adicionar foto apenas se foi selecionada uma nova
  if (fotoArquivo.value) {
    formData.append('photo', fotoArquivo.value);
  }

    store.dispatch('auth/updateProfile', formData).then(() => {
        // console.log(res)
        salvando.value = false;
        Swal.fire({
            title: 'Sucesso!',
            text: 'Seu perfil foi atualizado com sucesso.',
            icon: 'success',
            confirmButtonText: 'OK'
        }).then(() => {
            router.push('/profile');
        });
    }).catch(err => {
        salvando.value = false;
        console.error(err);
        Swal.fire({
            title: 'Erro!',
            text: 'Houve um problema ao atualizar seu perfil. Tente novamente.',
            icon: 'error',
            confirmButtonText: 'OK'
        });
    });
    
    
    

    // Voltar para o perfil após salvar
  
};

// Cancelar e voltar
const cancelar = () => {
  router.push('/profile');
};

// Voltar ao perfil
const voltarPerfil = () => {
  cancelar();
};
</script>

<style scoped>
.atualizar-perfil-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 16px;
}

.form-card {
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.foto-section {
  position: relative;
}

.foto-wrapper {
  display: inline-block;
  position: relative;
}

.profile-avatar {
  border: 4px solid #f5f5f5;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.upload-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.tips-card {
  border-radius: 12px;
  border-left: 4px solid #ffc107;
}

/* Estilo para input desabilitado */
:deep(.q-field--disabled .q-field__control) {
  background-color: #f5f5f5;
}

:deep(.q-field--disabled .q-field__native) {
  color: #757575 !important;
}

/* Animações */
.profile-avatar {
  transition: all 0.3s ease;
}

.foto-wrapper:hover .profile-avatar {
  transform: scale(1.05);
}

.upload-btn {
  transition: all 0.3s ease;
}

.foto-wrapper:hover .upload-btn {
  transform: scale(1.1);
}

@media (max-width: 599px) {
  .profile-avatar {
    width: 100px !important;
    height: 100px !important;
  }
}
</style>